/** @import FileItem from '@/classes/files/FileItem' */

/**
 * Conjunto de callbacks agrupados para conocer el estado de un fichero
 */
export default class StatusCallback {
  /** @type {function(FileItem): boolean} */ loading
  /** @type {function(FileItem): boolean} */ success
  /** @type {function(FileItem): boolean} */ warning
  /** @type {function(FileItem): boolean} */ error
}
